import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-521bbf8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "certify"
};
const _hoisted_2 = {
  id: "bgslide",
  class: "swiper-contaniner bgslide"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = {
  class: "swiper-slide"
};
const _hoisted_5 = {
  class: "bgbox"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "txtname"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_12 = {
  class: "txtdesc"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "canvasdiv"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "canvas"
}, null, -1));
const _hoisted_15 = {
  class: "swiper-wrapper"
};
const _hoisted_16 = {
  class: "swiper-slide"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "swiper-button-next"
};
const _hoisted_19 = {
  class: "swiper-button-prev"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`treasureList ${$data.isPc ? 'isPc' : ''}`)
  }, [_createElementVNode("div", _hoisted_1, [$data.isPc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "pcTitle",
    style: _normalizeStyle(`transform: scale(${$data.scale});top:${$data.pcTitleTop}px`)
  }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      alt: "",
      class: "swiper-lazy",
      src: item.itemformdata[3]
    }, null, 8, _hoisted_6)]), _createElementVNode("div", {
      class: "slideimg",
      onClick: $event => $options.openUrl(item.itemformdata[6]),
      style: _normalizeStyle(`transform: scale(${$data.scale})`)
    }, [_createElementVNode("img", {
      alt: "",
      class: "swiper-lazy",
      src: item.itemformdata[3]
    }, null, 8, _hoisted_8)], 12, _hoisted_7), _createElementVNode("div", {
      class: "slidetxt",
      onClick: $event => $options.openUrl(item.itemformdata[6]),
      style: _normalizeStyle(`transform: scale(${$data.scale})`)
    }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[2]), 1)]), _createElementVNode("h2", null, [_hoisted_11, _createTextVNode(_toDisplayString(item.itemformdata[1]), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("h3", null, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[4]), 1)]), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[5]), 1)])])], 12, _hoisted_9)]);
  }), 256))])]), _withDirectives(_createElementVNode("div", {
    id: "bottomslide",
    class: "swiper-container bottomslide",
    style: _normalizeStyle(`transform: scale(${$data.scale});bottom:${$data.showBottom ? '30px' : '-100px'}`)
  }, [_hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("img", {
      src: item.itemformdata[3],
      class: "swiper-lazy"
    }, null, 8, _hoisted_17)]);
  }), 256))]), _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [[_vShow, $data.isPc]]), _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [[_vShow, $data.isPc]])], 4), [[_vShow, $data.onLoad]])])], 2);
}